import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { useRecoilState } from 'recoil';

import Home from './Pages/Public/Home/Home';

import Loader from './Components/Loader/Loader';
import Modal from './Components/Modal/Modal';
import Navigation from './Components/Navigation/Navigation';

import NavigationList from './Data/Navigation.json';

import { loadingState, modalState } from './Recoil/Atoms';
import { setBasicModalSetter } from './Recoil/ModalController';
import Brand from './Pages/Public/Brand/Brand';
import ProductDetail from './Pages/Public/ProductDetail/ProductDetail';

const PublicLayout = () => (
    <>
        <Navigation menuItems={NavigationList} isPrivate={false} />
        <Outlet />
    </>
);

const App = () => {
    const [loading] = useRecoilState(loadingState);
    const [modal, setModalState] = useRecoilState(modalState);

    useEffect(() => {
        setBasicModalSetter(setModalState);
    }, [setModalState]);

    return (
        <Router>
            {loading ? (
                <Loader />
            ) : (
                <>
                    {/* ✅ Ensure modal appears only when it's open */}
                    {modal.isOpen && <Modal success={modal.success} message={modal.message} />}

                    <Routes>
                        <Route element={<PublicLayout />}>
                            <Route path='/:id/:product' element={<ProductDetail />} />
                            <Route path='/:id' element={<Brand />} />
                            <Route path='*' element={<Home />} />
                            <Route path='/' element={<Home />} />
                        </Route>
                    </Routes>
                </>
            )}
        </Router>
    );
};

export default App;
